var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63364 9.81732V13.7461C2.63364 17.6748 4.20864 19.2498 8.13739 19.2498H12.8536C16.7824 19.2498 18.3574 17.6748 18.3574 13.7461V9.81732",
    stroke: "#564ECE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5011 10.5002C12.1024 10.5002 13.2836 9.19643 13.1261 7.59518L12.5486 1.75018H8.46239L7.87614 7.59518C7.71864 9.19643 8.89989 10.5002 10.5011 10.5002Z",
    stroke: "#564ECE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.025 10.5002C17.7925 10.5002 19.0875 9.06518 18.9125 7.30643L18.6675 4.90018C18.3525 2.62518 17.4775 1.75018 15.185 1.75018H12.5162L13.1287 7.88393C13.2775 9.32768 14.5812 10.5002 16.025 10.5002Z",
    stroke: "#564ECE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93685 10.5002C6.3806 10.5002 7.68435 9.32768 7.82435 7.88393L8.01685 5.95018L8.43685 1.75018H5.7681C3.4756 1.75018 2.6006 2.62518 2.2856 4.90018L2.04935 7.30643C1.87435 9.06518 3.16935 10.5002 4.93685 10.5002Z",
    stroke: "#564ECE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4986 14.8752C9.03731 14.8752 8.31106 15.6014 8.31106 17.0627V19.2502H12.6861V17.0627C12.6861 15.6014 11.9598 14.8752 10.4986 14.8752Z",
    stroke: "#564ECE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.c806d2d2eee6864f1423dd903a10eb15.svg";
export { ForwardRef as ReactComponent };